<template>
  <div class="bg-img">
    <div class="title">西南交通大学网络教育学院毕业设计管理信息系统</div>
    <!--    <div class="prompt">本系统在3月29日-4月12日开放，请先加入工作QQ群：398580894。</div>-->
    <el-form
      :rules="rules"
      ref="loginForm"
      v-loading="loading"
      element-loading-text="正在登录..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :model="loginForm"
      class="loginContainer">
      <h3 class="loginTitle">系统登录</h3>
      <el-form-item prop="username">
        <el-input size="normal" type="text" v-model="loginForm.username" auto-complete="off"
                  placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input size="normal" type="password" v-model="loginForm.password" auto-complete="off"
                  placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input size="normal" type="text" v-model="loginForm.code" auto-complete="off"
                  placeholder="点击图片更换验证码" @keydown.enter.native="submitLogin" style="width: 250px"></el-input>
        <img :src="vcUrl" @click="updateVerifyCode" alt="" style="cursor: pointer">
      </el-form-item>
      <el-checkbox size="normal" class="loginRemember" v-model="loginForm.rememberMe">一周内免登录</el-checkbox>
      <el-button size="normal" type="primary" style="width: 100%;" @click="submitLogin">登录</el-button>
    </el-form>
    <div class="CopyrightTips">
      西南交通大学网络教育学院 毕业设计管理信息系统<br/>
      版权所有：西南交通大学网络教育学院<br/>
      教学及学生支持服务中心：028-87600342<br/>
      备案号：蜀ICP备05026985号-2
    </div>
  </div>
</template>

<script>

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      vcUrl: this.$store.state.basePath + '/verifyCode?time=' + new Date(),
      loginForm: {
        username: '',
        password: '',
        code: null,
        rememberMe: true
      },
      rules: {
        username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
        code: [{required: true, message: '请输入验证码', trigger: 'blur'}]
      }
    }
  },
  methods: {
    updateVerifyCode() {
      this.vcUrl = this.$store.state.basePath + '/verifyCode?time=' + new Date();
    },
    submitLogin() {
      var me = this;
      me.$refs.loginForm.validate((valid) => {
        if (valid) {
          me.loading = true;
          me.postRequest(me.$store.state.basePath + '/doLogin', me.loginForm).then(resp => {
            me.loading = false;
            if (resp) {
              if (resp.error != null) {
                me.$message.error(resp.error);
                me.vcUrl = me.$store.state.basePath + '/verifyCode?time=' + new Date();
              } else {
                me.$store.commit('INIT_CURRENTUSER', resp.currentUser);
                window.sessionStorage.setItem("currentUser", JSON.stringify(resp.currentUser));
                // me.$store.commit('INIT_TOPROLE', resp.topRole);
                // let topRole = JSON.stringify(resp.topRole);
                // me.$store.state.topRole = topRole;
                // window.sessionStorage.setItem("topRole", JSON.stringify(resp.topRole));
                let path = me.$route.query.redirect;
                // console.log(path);
                me.$router.replace((path == '/' || path == undefined) ? '/Home' : path);
              }
            } else {
              me.vcUrl = me.$store.state.basePath + '/verifyCode?time=' + new Date();
            }
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style>
.bg-img {
  background: url('/static/background02.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.title {
  color: white;
  /*#409EFF;*/
  /*padding-top: 100px;*/
  padding-top: 50px;
  font-size: 40px;
}

.prompt {
  text-align: center;
  color: red;
  font-size: 28px;
}

.elinput {
  border: none;
}

.loginContainer {
  border-radius: 15px;
  background-clip: padding-box;
  /*margin: 100px auto;*/
  margin: 50px auto;
  width: 350px;
  padding: 15px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  /* box-shadow: 0 0 25px #cac6c6; */
}

.CopyrightTips {
  color: black;
  /*#409EFF;*/
  /*padding-top: 150px;*/
  font-family: PingFang SC;
}

/* .loginContainer{
  width: 580px;
  height: 560px;
  background: #FFFFFF;
  box-shadow: 0px 0px 70px 0px rgba(18, 43, 80, 0.36);
  border-radius: 20px;
  margin: 100px auto;

} */
.loginTitle {
  /* margin: 15px auto 20px auto; */
  text-align: center;
  color: #505458;
  border-bottom: 2px solid #cccccc;
  padding-bottom: 20px;
  margin: 5px auto 40px auto;
}

.loginRemember {
  text-align: left;
  margin: 0px 0px 15px 0px;
}

.el-form-item__content {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue